import { Car, CarFront, Gauge, Mountain, Compass, Truck } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { Reveal, Eyebrow } from "./Reveal";

const ICONS = [Car, CarFront, Gauge, Mountain, Compass, Truck];

export const Offer = () => {
  const { t } = useLang();
  const o = t.offer;
  return (
    <section id="offer" data-testid="offer-section" className="section-flow py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="grid items-start gap-14 lg:grid-cols-[1fr_1.1fr] lg:gap-20">
          <Reveal className="lg:sticky lg:top-28">
            <img src="/img/showroom.jpg" alt="Wholesale vehicle selection" className="aspect-[4/5] w-full rounded-3xl object-cover shadow-[0_30px_60px_-30px_rgba(10,37,64,.5)]" />
          </Reveal>
          <Reveal delay={100}>
            <Eyebrow>{o.eyebrow}</Eyebrow>
            <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-[44px] lg:leading-[1.1]">{o.title}</h2>
            <div className="mt-8 space-y-5 text-base leading-relaxed text-slate-300">
              {o.p.map((p) => <p key={p}>{p}</p>)}
            </div>
            <h3 className="mt-12 text-xs font-bold uppercase tracking-[0.2em] text-slate-400">{o.segmentsTitle}</h3>
            <div className="mt-5 grid grid-cols-2 gap-3 sm:grid-cols-3">
              {o.segments.map((s, i) => {
                const Icon = ICONS[i];
                return (
                  <div key={s} data-testid={`segment-card-${i}`} className="group rounded-2xl bg-white/[0.04] p-5 shadow-[0_8px_30px_-18px_rgba(0,0,0,.6)] ring-1 ring-white/10 transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-[0_18px_40px_-18px_rgba(47,123,255,.55)]">
                    <Icon className="h-7 w-7 text-white transition-colors group-hover:text-[#2F7BFF]" strokeWidth={1.6} />
                    <div className="mt-4 text-[15px] font-bold text-white">{s}</div>
                  </div>
                );
              })}
            </div>
            <div data-testid="offer-goal" className="mt-10 rounded-2xl bg-gradient-to-r from-[#1F63E0] to-[#2F7BFF] p-7 shadow-[0_20px_50px_-20px_rgba(47,123,255,.7)] font-display text-lg font-semibold leading-snug text-white sm:text-xl">
              {o.goal}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
